import { IAdditionalInfoFormContent } from "./AdditionalInfoForm";
import { IBasicInfoFormContent } from "./BasicInfoForm";

export enum FormTab {
  basic,
  additional,
}

export interface IEditBasicInfoContent {
  basicTab: string;
  additionalTab: string;
  switchToNextTabText: string;
  switchToPreviousTabText: string;
  additionalInfoForm: IAdditionalInfoFormContent;
  basicInfoForm: IBasicInfoFormContent;
}
export const IEditBasicInfoContentKeys = [
  "basicTab",
  "additionalTab",
  "switchToNextTabText",
  "switchToPreviousTabText",
  "additionalInfoForm",
  "basicInfoForm",
];
